module.exports = __webpack_public_path__ + "static/media/solvemoji_cover_junior.594bb761.jpeg";